import { ActionContext } from 'vuex';
import { HttpStore } from '@integrai/ui';
import StateType from './state.type';

export default {
  async getInvoiceConfiguration(context: ActionContext<StateType, any>): Promise<any> {
    const { commit } = context || {};

    commit('toggleLoading', true);

    try {
      const response: any = await HttpStore.get('invoices/configuration');

      commit('setInvoiceConfiguration', response);
      commit('toggleLoading', false);
    } catch {
      commit('toggleLoading', false);
    }
  },
  async getPreSignedUrl(context: ActionContext<StateType, {}>): Promise<void> {
    const { commit } = context || {};

    commit(
      'setPreSignedUrlCertificate',
      await HttpStore.get('invoices/configuration/pre-signed-url?type=CERTIFICATE'),
    );

    commit(
      'setPreSignedUrlLogo',
      await HttpStore.get('invoices/configuration/pre-signed-url?type=LOGO'),
    );
  },
  async updateInvoiceConfiguration(
    context: ActionContext<StateType, any>,
    invoiceConfiguration: any,
  ): Promise<any> {
    const { commit } = context || {};

    commit('toggleLoadingSave', true);

    try {
      await HttpStore.put('invoices/configuration', invoiceConfiguration);

      commit('toggleLoadingSave', false);
    } catch {
      commit('toggleLoadingSave', false);
    }
  },
};
